import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ApiService from "../services/ApiService";
import { useEffect } from "react";

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = React.useState({
    username: "",
    password: "",
    repeatPassword: "",
    agreedToTerms: false,
  });

  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const [showPassword, setShowPassword] = React.useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/clone-list");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&._])[A-Za-z\d@$!%*?&._]{8,}$/;
    return passwordRegex.test(password);
  };

  const handleRegistration = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);

    const {
      username,
      password,
      repeatPassword,
      agreedToTerms,
    } = formData;

    if (!username || !password || !repeatPassword) {
      setError("All fields are required.");
      setLoading(false);
      return;
    }
    if (password !== repeatPassword) {
      setError("Passwords do not match!");
      setLoading(false);
      return;
    }
    if (!validatePassword(password)) {
      setError(
        "Password must be at least 8 characters long, include a number, a special character, and an uppercase letter."
      );
      setLoading(false);
      return;
    }
    if (!agreedToTerms) {
      setError("You must agree to the privacy policy and terms.");
      setLoading(false);
      return;
    }

    try {
      const res = await ApiService.post("/api/auth/register", {
        password,
        username,
        role: "user",
      });

      toast.success("User registered successfully!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      localStorage.setItem("token", res.token);

      setTimeout(() => {
        navigate("/clone-list");
      }, 2100);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleRegistration(e);
    }
  };


  return (
    <div className="tyn-root">
      <div className="tyn-content tyn-auth tyn-auth-centered">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div className="card border-0 py-4">
                <div className="my-3 text-center d-flex align-items-center justify-content-center">
                  <Link className="tyn-logo tyn-logo-sm" to="/">
                    <img
                      src="/images/logo/bardo-icon.png"
                      alt="Bardo logo"
                      className="logo-icon"
                    />
                    <img
                      src="/images/logo/bardo-text.png"
                      alt="Bardo logo"
                      className="logo-text"
                    />
                  </Link>
                </div>
                <form className="p-4" onSubmit={handleRegistration} onKeyDown={handleKeyDown}>
                  <h3>Create Account</h3>
                  {error && <p className="text-danger small">{error}</p>}
                  <div className="row g-3 gx-4">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="email">
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="username"
                          name="username"
                          placeholder="youremail@example.com"
                          value={formData.username}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group position-relative">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <span
                          className="position-absolute end-0 pb-5 mt-1 translate-middle-y pe-3 cursor-pointer"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={`bi ${!showPassword ? "bi-eye-slash" : "bi-eye"
                              }`}
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group position-relative">
                        <label className="form-label" htmlFor="repeatPassword">
                          Repeat Password
                        </label>
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="repeatPassword"
                          name="repeatPassword"
                          placeholder="Repeat Password"
                          value={formData.showPassword}
                          onChange={handleChange}
                        />
                        <span
                          className="position-absolute end-0 pb-5 mt-1 translate-middle-y pe-3 cursor-pointer"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={`bi ${!showPassword ? "bi-eye-slash" : "bi-eye"
                              }`}
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="privacy-term-agree"
                          name="agreedToTerms"
                          checked={formData.agreedToTerms}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="privacy-term-agree"
                        >
                          I agree to the <Link to="/">privacy policy & terms</Link>.
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Registering..." : "Register Account"}
                      </button>
                    </div>
                  </div>
                </form>
                <div className="text-center mt-3 my-3">
                  <p>
                    Already have an account?{" "}
                    <Link to="/login" className="link link-primary" style={{ fontSize: "16px" }}>
                      Log In.
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <ChatbotToggle/> */}
    </div>
  );
};

export default Register;
